import React from 'react';
import { useLocation } from 'react-router-dom';

// Import main components
import ManageClients from './ManageClients/ManageClients';
import OnboardingPipeline from './OnboardingPipeline/OnboardingPipeline';

// Export individual components for direct imports
export { default as ManageClients } from './ManageClients/ManageClients';
export { default as OnboardingPipeline } from './OnboardingPipeline/OnboardingPipeline';

// Export shared components
export { default as ClientCard } from './components/shared/ClientCard';
export { default as ClientTable } from './components/shared/ClientTable';
export { default as ClientStatsCard } from './components/shared/ClientStatsCard';

// Export types, constants, and utilities
export * from './types';
export * from './constants';
export * from './utils/clientUtils';

const ClientsRouter: React.FC = () => {
  const location = useLocation();

  // Route directly based on path instead of using tabs
  if (location.pathname === '/clients/onboarding') {
    return <OnboardingPipeline />;
  }

  // Default to ManageClients for /clients
  return <ManageClients />;
};

export default ClientsRouter; 